import { http } from '@/lib/http';
import { createHttpClient, postNewsLetter as postNewsLetterCommon } from '@monorepo/common';

export type { PostNewsLetterParams, PostNewsLetterResponse } from '@monorepo/common';

export const postNewsLetter = async (params: { permission: number }) => {
  const httpClient = createHttpClient(http);
  return await postNewsLetterCommon(params, httpClient);
};
